import $ from 'jquery'

$(document).on('change', '.js-sellers-deals-busines', ({ currentTarget }) => {
  $(currentTarget)
    .closest('form')
    .submit()
})
